import { ScheduleEventResponse } from '../views/scheduleMeeting/interfaces/ScheduleEvents.interface';

export type EventTypeHint = Pick<ScheduleEventResponse, 'type_value'> | ScheduleEventResponse;

/**
 * Check if a service is a round-robin event
 * Round-robin events have type_value === 2
 */
export const isRoundRobinEvent = (
  service: EventTypeHint | null | undefined
): boolean => {
  return service?.type_value === 2;
};
